import Vue from 'vue';
import Router from 'vue-router';
import aboutView from '@/components/about.vue';
import homePageView from '@/components/home.vue';
import contactView from '@/components/contact.vue';
import KLabView from '@/components/klab.vue';
import KLabEduView from '@/components/klab-edu.vue';
import jobView from '@/components/job.vue';
import partnerView from '@/components/partner.vue';
import caseView from '@/components/case.vue';
import productView from '@/components/production.vue';

Vue.use(Router);

const routes = [{
  path: '/',
  name: 'home',
  component: homePageView
}, {
  path: '/about',
  name: 'about',
  component: aboutView,
  meta: {
    title: '关于和鲸'
  }
}, {
  path: '/contact',
  name: 'contact',
  component: contactView,
  meta: {
    title: '联系方式'
  }
}, {
  path: '/K-Lab',
  name: 'K-Lab',
  component: KLabView,
  meta: {
    title: 'K-Lab介绍'
  }
}, {
  path: '/K-Lab-edu',
  name: 'K-Lab-edu',
  component: KLabEduView,
  meta: {
    title: 'K-Lab教育版'
  }
}, {
  path: '/job',
  name: 'job',
  component: jobView,
  meta: {
    title: '加入我们'
  }
}, {
  path: '/partner',
  name: 'partner',
  component: partnerView,
  meta: {
    title: '客户案例'
  }
}, {
  path: '/case/:id',
  name: 'case',
  component: caseView,
  meta: {
    title: '客户案例'
  }
}, {
  path: '/product',
  name: 'product',
  component: productView,
  meta: {
    title: '产品与服务'
  }
}, {
  path: '*',
  redirect: '/'
}];

const router = new Router({
  routes,
  mode: 'hash',
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

const isTestEnv = location.href.indexOf('test-0a4a126e') > -1;
router.afterEach((route) => {
  if (route.meta && route.meta.title) {
    window.document.title = route.meta.title + ' - 和鲸';
  } else {
    window.document.title = '和鲸';
  }
  if (window._hmt && !isTestEnv) {
    window._hmt.push(['_trackPageview', 'https://www.heywhale.com' + route.fullPath]);
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js